import { useEffect, useState } from "react";
import api from "../../lib/api";

const card = "rounded-2xl border border-adminborder bg-admincard";

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => setLogs([])); }, []);

  if (!logs) return <p className="py-20 text-center text-slate-500">Loading audit logs…</p>;

  return (
    <div data-testid="admin-audit" className="space-y-6">
      <h1 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl">Audit Logs</h1>
      <div className={`${card} overflow-x-auto`}>
        <table className="w-full text-sm" data-testid="audit-table">
          <thead>
            <tr className="border-b border-adminborder text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-5 py-3.5">Action</th><th className="px-5 py-3.5">Actor</th>
              <th className="px-5 py-3.5">Details</th><th className="px-5 py-3.5">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-adminborder/60 last:border-0">
                <td className="px-5 py-3.5"><span className="rounded-full bg-saffron/15 px-2.5 py-1 text-xs font-bold text-saffron">{l.action}</span></td>
                <td className="px-5 py-3.5 text-slate-400">{l.actor_email}</td>
                <td className="px-5 py-3.5 text-slate-300">{l.details}</td>
                <td className="px-5 py-3.5 font-mono text-xs text-slate-500">{new Date(l.created_at).toLocaleString("en-IN")}</td>
              </tr>
            ))}
            {!logs.length && <tr><td colSpan={4} className="px-5 py-12 text-center text-slate-500">No audit events yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
